import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';

export const ShimmerPlaceholder = styled.div<{}, ITheme>`
	background: ${themed(({ shimmer }) => shimmer.placeholder.background)};
	border-radius: ${themed(({ shimmer }) => shimmer.placeholder.borderRadius)};
`;
